<template>
    <div class="share-interaction-c" >
        <!-- 点赞 -->
        <Like :likeData="likeData"/>
        <!-- 评论 -->
        <div class="comment-wrap" id="leftComment">
            <div class="item">
                <img :src="commentIcon"/>
                <div class="first-comment-tag" v-if="showFirstComment">抢首评</div>
            </div>
            <div class="count comment-count"></div>
        </div>
        <!-- 收藏 -->
        <Collection :collectionData="collectionData"/>
        <!-- 分享 -->
        <Share/>
        <!-- 二维码 -->
        <PhoneScan/>
    </div>
</template>
<script>
import PhoneScan from './phoneScan.vue'
import Share from './share.vue'
import Collection from './collection.vue'
import Like from './like.vue'
import { getInteracitonCountApi } from '@/request/request'
import { CommentStore } from '@/store/index'

export default {
    components: {
        PhoneScan,
        Share,
        Collection,
        Like
    },
    data() {
        return {
            commentIcon: '//statics.itc.cn/mptc-mpfe/img/article/icon_comment.png',
            shareIcon: '//statics.itc.cn/mptc-mpfe/img/article/icon_share_empty.png',
            collectionData: {},
            likeData: {}
        }
    },
    computed: {
        showFirstComment() {
            return CommentStore.showFirstComment
        }
    },
    mounted() {
        this.handleSticky()
        this.getInteracitonCount()
        this.jumpToComment()
    },
    methods: {
        // 评论跳转(js控制，css不准)
        jumpToComment() {
            const leftCommentDom = document.querySelector('#leftComment')
            if(!leftCommentDom) return
            // url携带#comment_area跳转
            if(window.location.hash == '#comment_area') {
                if ('scrollRestoration' in history) {
                    history.scrollRestoration = 'manual'; // 禁止自动恢复滚动位置
                }
                setTimeout(()=>{
                    window.scrollTo(0, document.getElementById("meComment")?.offsetTop);
                },1500)
            }
            // 左侧评论跳转
            leftCommentDom.addEventListener('click',()=>{
                if(window.location.hash != '#comment_area') {
                    window.location.hash = '#comment_area'
                }
                window.scrollTo(0, document.getElementById("meComment")?.offsetTop);
                window.sohuSpm?.sendAction({acode: this.showFirstComment ? '11113' : '11128'})
            })
        },       // 获取互动数量
        async getInteracitonCount() {
            let res = await getInteracitonCountApi()
            if(res.code == 1 && res.data) {
                let countObj = res?.data?.[`mp_${window.pcArticleInfo?.news_id}`]
                // 点赞
                this.likeData = {
                    isLiked : countObj?.[12]?.optionInfos?.[0]?.operated,
                    likeCount : countObj?.[12]?.optionInfos?.[0]?.count
                }
                console.log(333,this.likeData)
                // 收藏
                this.collectionData = {
                    isCollection: countObj?.[11]?.optionInfos?.[0]?.operated,
                    collectionCount: countObj?.[11]?.optionInfos?.[0]?.count
                }
            }
        },
        handleSticky() {
            // 获取要吸顶的元素
            const stickyElement = document.querySelector('.share-interaction-c');
            // 获取元素距离页面顶部的初始偏移量
            const initialOffsetTop = stickyElement.offsetTop;

            // 监听页面滚动事件
            window.addEventListener('scroll', function () {
                // 获取当前页面滚动的垂直距离
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                if (scrollTop >= initialOffsetTop) {
                    // 如果滚动距离大于等于初始偏移量，添加固定定位样式类
                    stickyElement.classList.add('fixed');
                } else {
                    // 如果滚动距离小于初始偏移量，移除固定定位样式类
                    stickyElement.classList.remove('fixed');
                }
            });
        }
    }
}
</script>
<style lang="less" scoped>
    .share-interaction-c {
        z-index: 1;
        width: 140px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .comment-wrap {
            &:hover {
                cursor: pointer;
            }
            .item {
                width: 48px;
                height: 48px;
                background: #F8F8F8;
                border-radius: 2px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                position: relative;
                img {
                    width: 22px;
                    height: 22px;
                }
                .first-comment-tag {
                    position: absolute;
                    right: -17px;
                    top: 2px;
                    font-weight: 600;
                    font-size: 12px;
                    color: #111111;
                    line-height: 17px;
                    background: #FFD100;
                    border-radius: 11px;
                    border: 1px solid #FFFFFF;
                    padding: 0 4px;
                    box-sizing: border-box;
                }
            }
            .item:hover {
                background: #f2f2f2;
            }
            .count {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #111111;
                line-height: 17px;
                height: 17px;
                text-align: left;
                font-style: normal;
                text-align: center;
                margin-top: 4px;
                margin-bottom: 24px;
            }
        }
    }
    .fixed {
        position: fixed;
        top: 72px;
    }
</style>